import { render, staticRenderFns } from "./EditAdminAccount.vue?vue&type=template&id=57672003&"
import script from "./EditAdminAccount.vue?vue&type=script&lang=js&"
export * from "./EditAdminAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports